import { actionCreators as taskLogActionCreators } from "Areas/SharedFeatures/tasksLogs";
import { connect } from "react-redux";
import { actionCreators, getOutdated, getTasks, getTasksInProgress } from "../../redux";
import TasksInner from "./tasks.inner";
const mapStateToProps = (state, ownProps) => ({
    inProgress: ownProps.inProgress || getTasksInProgress(state, ownProps.documentId),
    tasks: getTasks(state, ownProps.documentId),
    outdated: getOutdated(state, ownProps.documentId)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (documentId) => dispatch(actionCreators.getTasks(documentId)),
    onStopRequestTask: (requestTaskId) => dispatch(actionCreators.stopRequestTask(requestTaskId)),
    onRestartRequestTask: (requestTaskId) => dispatch(actionCreators.restartRequestTask(requestTaskId)),
    onGetRequestTask: (requestTaskId) => dispatch(actionCreators.getRequestTask(requestTaskId)),
    onTaskLogOpen: (show, sourceTaskIds, title) => dispatch(taskLogActionCreators.toggleTasksLogsResult(show, sourceTaskIds, title)),
    onHighlightTaskResults: (sourceTaskIds, documentId) => dispatch(actionCreators.setSourceTaskIdsToHighlight(sourceTaskIds, documentId))
});
export default connect(mapStateToProps, mapDispatchToProps)(TasksInner);
